import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { restServices } from 'src/app/rest.service';
import { FileModello } from '../../models/entities/file-modello';
import { RichiestaInformazioni } from '../../models/entities/richiesta-informazioni';

type EntityResponseType = HttpResponse<FileModello>;
type EntityArrayResponseType = HttpResponse<FileModello[]>;

@Injectable()
export class FileModelloService {

  resourceUrl = environment.api_rischiocambio_url + restServices.fileModellos;

  constructor(protected http: HttpClient) {
  }

  create(fileModello: FileModello): Observable<EntityResponseType> {
    return this.http.post<FileModello>(this.resourceUrl, fileModello, { observe: 'response' });
  }

  update(fileModello: FileModello): Observable<EntityResponseType> {
    return this.http.put<FileModello>(this.resourceUrl, fileModello, { observe: 'response' });
  }

  getAll(): Observable<EntityArrayResponseType> {
    return this.http.get<FileModello[]>(this.resourceUrl, { observe: 'response' });
  }

  findStrumentiUtilizzabiliByTenant(input: any): Observable<EntityArrayResponseType> {
    return this.http.post<FileModello[]>(`${this.resourceUrl}/${restServices.strumentiUtilizzabili}`, input, { observe: 'response' });
  }

  findMarketStrumentiByTenant(input: any): Observable<EntityArrayResponseType> {
    return this.http.post<FileModello[]>(`${this.resourceUrl}/${restServices.marketStrumenti}`, input, { observe: 'response' });
  }

  find(id: number): Observable<EntityResponseType> {
    return this.http.get<FileModello>(`${this.resourceUrl}/${id}`, { observe: 'response' });
  }

  findWithoutContent(id: number): Observable<EntityResponseType> {
    return this.http.get<FileModello>(`${this.resourceUrl}/${restServices.noContent}/${id}`, { observe: 'response' });
  }

  findAndUpdateNumeroDownload(input: any): Observable<EntityResponseType> {
    return this.http.post<FileModello>(`${this.resourceUrl}/${restServices.updateNumeroDownload}`, input, { observe: 'response' });
  }

  delete(id: number): Observable<HttpResponse<{}>> {
    return this.http.delete(`${this.resourceUrl}/${id}`, { observe: 'response' });
  }

  richiediInformazioni(richiestaInformazioni: RichiestaInformazioni) {
    return this.http.post((this.resourceUrl + '/' + restServices.richiediInformazioni), richiestaInformazioni, { responseType: 'text' });
  }
}
